<template>
  <Modal v-model="model" sticky reset-drag-position title="自定义菜单" @on-cancel="cancel" scrollable :mask="false" draggable class="custom_menu_pop" width="900">
    <div>
      <el-col :span="24" style=" margin-top:-10px;">
        <div style="width:900px">
          <p style="display:inline-block;margin-top:5px;marin-right:15px;padding-right:10px;letter-spacing:2px;font-size:12px">菜单状态:</p>
          <el-radio-group v-model="menuStatus">
            <Tooltip class="tips_font" placement="bottom">
              <div slot="content">
                <p>点击开启</p>
              </div>
              <el-radio :label="1" >开启</el-radio>
            </Tooltip>
            <Tooltip class="tips_font" placement="bottom">
              <div slot="content">
                <p>点击关闭</p>
              </div>
              <el-radio :label="0" >关闭</el-radio>
            </Tooltip>
          </el-radio-group>
          <p style="display:inline-block;margin-top:5px;margin-left:15px;letter-spacing:2px;font-size:12px;color:red">温馨提示:开启菜单后,编辑的内容会替换原公众号的自定义菜单,请谨慎开启</p>
        </div>
        <div class="flex" v-if="openPreview && menuStatus === 1"></div>
        <el-col :span="24" v-if="menuStatus === 1" style=" margin-top:15px;">
          <el-col :span="5" class="left">
            <img class="top" :src="require('@/assets/image/topWx.png')" />
<!--            <img class="bottom" :src="require('@/assets/image/wxKeyBored.png')" />-->
            <div style="background: #F4F5F9; min-height: 400px; position: absolute; top: 63px; width: 320px;">
              <div class="textBot">
                <div class="li" v-for="(item,indexOne) in list" :key="indexOne" >
                  <div v-if="activeIndex === indexOne">
                    <div :class="item.sub_button.length < 5 ? 'addTheChild':'addJiaFull'">
                      <div style="overflow:hidden;text-overflow:ellipsis;" class="addClass" v-for="(item,index) in item.sub_button" :key="index"
                          :class="addIndex === index ? 'active':''" @click="getChildItem(item,index)">{{item.name}}</div>
                    </div>
                    <div class="add" @click="add(indexOne)" v-if="item.sub_button.length < 5 ">
                      <i class="el-icon-plus"></i>
                      <div class="arrow"></div>
                    </div>
                  </div>
                  <div class="text" :class="activeClass === indexOne ? 'active':''" @click="getFatherItem(item,indexOne)">{{item.name}}</div>
                </div>
                <div class="li" v-if="list.length < 3">
                  <div class="text" @click="addText"><i class="el-icon-plus"></i></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="14" v-if="activeClass !== -1 || addIndex !== -1" style=" padding-left: 20px;">
            <el-card class="box-card right">
              <div slot="header" class="clearFix">
                <span>{{input}}</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="deleteMean">删除菜单</el-button>
              </div>
              <div style="display: flex;">
                <label style="line-height: 34px; width:80px;">菜单名称</label>
                <el-input v-model="input" placeholder="请输入内容" :title="input" style="width:70%;overflow:hidden;text-overflow:ellipsis;" ></el-input>
              </div>
              <p v-if="'1' === listRightDetail.meanType" style="color: #9A8D8D;margin-left: 80px;">仅支持中英文和数字，字数不超过7个汉字或14个字母</p>
              <p v-if="'0' === listRightDetail.meanType" style="color: #9A8D8D;margin-left: 80px;">仅支持中英文和数字，字数不超过4个汉字或8个字母</p>
              <div v-if="!clickFlag" style="display: flex;">
                <label style="line-height: 34px; width:80px;">菜单内容</label>
                <el-radio-group v-model="listRightDetail.type" style="line-height: 45px;">
                  <el-radio :label="1">发送消息</el-radio>
                  <el-radio :label="2">跳转的网页</el-radio>
                  <el-radio :label="3">人工服务</el-radio>
                </el-radio-group>
              </div>
              <div v-show="listRightDetail.type === 1 && !clickFlag">
                <textarea v-model="listRightDetail.content" class="input_content" :rows="8" :autosize="{minRows: 4}" style="width: 100%;background: #fff;resize:both;" />
              </div>
              <div style="background: #fff;padding:10px 0;" v-show="listRightDetail.type === 2 && !clickFlag">
                <p style="color: #9A8D8D;margin-left: 30px;">订阅者在公众号点击该子菜单会跳到以下链接</p>
                <p style="color: #9A8D8D;margin-left: 30px;">(链接格式为http://www.***.com)</p>
                <div style="display: flex; padding:0 30px;">
                  <label style="line-height: 34px; width:65px;">页面地址</label>
                  <el-input v-model="listRightDetail.url" @input="change($event)" placeholder="请输入内容" style="width:70%;"></el-input>
                </div>
              </div>
              <div v-show="listRightDetail.type === 3 && !clickFlag" style="display:flex;width:100%;margin-bottom:20px;margin-left:15%" >
                <p style="margin-right:15px">人工服务发起方式</p>
                <RadioGroup v-model="listRightDetail.chatContent" >
                  <Radio :label="1" >直接发消息或点击菜单</Radio>
                  <Radio :label="2" >点击菜单</Radio>
                </RadioGroup>
              </div>
            </el-card>
          </el-col>
          <el-col :span="14" v-if="activeClass === -1 && addIndex === -1" style=" padding-left: 20px;">
              <h2 style="text-align: center;">点击左侧菜单进行编辑操作</h2>
          </el-col>
        </el-col>
        <el-col :span="24">
          <el-button type="primary" style="display: block;margin: 10px auto;" @click="saveSet">保存并发布</el-button>
        </el-col>
      </el-col>
    </div>
    <div hidden slot="footer">
      <Button  type="primary" class="submit_btn" >确认</Button>
      <Button type="error" class="cancel_btn" >取消</Button>
    </div>
  </Modal>
</template>

<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'

export default {
  name: 'CustommenuPop',
  mixins: [publicFunClass],
  props: {
    showcustommenu: Boolean,
    searchId: String,
  },
  data() {
    return {
      agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
      model: false,
      menuStatus:1,
      bottom: '',
      activeClass: -1,
      addIndex: -1,
      input: '',
      type: 1,
      radioBottom: 0,
      shu: 30,
      id: 1,
      list: [],
      activeIndex:0,
      clickFlag:false,
      openPreview: false,
      isErrorFlag:false,
      listRightDetail: {name:'',meanType:'',url:'',id:0,type:1,chatContent:1,content:'',},
    }
  },
  methods: {
    //TODO 无法渲染数据，先暂时强制刷新
    change(e) {
      this.$forceUpdate()
    },
    // 父元素
    getFatherItem (item, index) {
      this.checkValue();
      if(this.isErrorFlag){
        return false;
      }
      this.clickFlag = false;
      if(item.sub_button && item.sub_button.length > 0){
        this.clickFlag = true;
      }
      this.addIndex = -1;
      this.activeIndex = index;
      this.activeClass = index;// 把当前点击元素的index，赋值给activeClass
      this.input = item.name;
      this.id = item.id;
      this.listRightDetail = item;
    },
    // 子元素
    getChildItem (item, index) {
      this.checkValue();
      if(this.isErrorFlag){
        return false;
      }
      this.clickFlag = false;
      this.activeClass = -1;
      this.addIndex = index;
      this.input = item.name;
      this.id = item.id;
      this.listRightDetail = item;
    },
    // 增加
    add (index) {
      if(this.list && this.list.length > 0){
        this.checkValue();
      }
      if(this.isErrorFlag){
        return false;
      }
      this.shu++
      this.list[index].sub_button.push({
        'name':'添加子菜单',meanType:'1',url:'',id:this.shu,type:1,chatContent:1,content:'',
      });
      let newList = this.list[index].sub_button;
      this.getChildItem(newList[newList.length-1],newList.length-1);
    },
    //检查页面数据是否符合逻辑
    checkValue(){
      if(!this.listRightDetail.meanType){
        return;
      }
      let checkTemp = 8;
      let message = "仅支持中英文和数字，字数不超过4个汉字或8个字母且不能为空";
      if('1' === this.listRightDetail.meanType){
        //子菜单校验
        checkTemp = 14;
        message = "仅支持中英文和数字，字数不超过7个汉字或14个字母且不能为空";
      }
      let temp = 0
      for (let k = 0; k < this.input.length; k++) {
        if (/[\u4e00-\u9fa5]/.test(this.input[k])) {
          temp += 2
        } else {
          temp++
        }
      }

      if (temp > checkTemp || !this.input || !/^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(this.input)) {
        this.$message({
          message: message,
          type: 'warning'
        });
        this.isErrorFlag = true;
        return;
      }
      if(2 === this.listRightDetail.type){
        //网址校验
        let reg=/(http|https):\/\/([\w.]+\/?)\S*/;
        if(!reg.test(this.listRightDetail.url)){
          this.$message({
            message: '请检查网址是否正确',
            type: 'warning'
          });
          this.isErrorFlag = true;
          return;
        }
      }
      this.isErrorFlag = false;
      return;
    },
    addText () {
      if(this.list && this.list.length > 0){
       this.checkValue();
      }
      if(this.isErrorFlag){
        return false;
      }
      this.shu++
      this.list.push({
        'name': '添加菜单',meanType:'0',url:"",id:this.shu,type:1,chatContent:1,content:'',sub_button: []
      })
      let newList = this.list;
      this.getFatherItem(newList[newList.length-1],newList.length-1);
    },
    // 删除
    deleteMean () {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let i = 0; i < this.list.length; i++) {
          for (let j = 0; j < this.list[i].sub_button.length; j++) {
            if (this.list[i].sub_button[j].id === this.id) {
              this.list[i].sub_button.splice(j, 1)
              this.addIndex = -1
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.clickFlag=false;
              this.openPreview=false;
              this.isErrorFlag=false;
              this.listRightDetail={};
              this.activeClass = -1;
              this.addIndex=-1;
              this.isErrorFlag = false;
            }
          }
          if (this.list[i].id === this.id) {
            this.list.splice(i, 1)
            this.activeClass = -1;
            this.activeIndex = -1;
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    cancel: function () {
      this.$emit('closecustommenu', false)
    },
    saveSet: function () {
      this.checkValue();
      if(this.isErrorFlag){
        return false;
      }
      this.$confirm('此操作会覆盖原有菜单，是否确认开启?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let i = 0; i < this.list.length; i++) {
          this.$delete(this.list[i],'id');
          this.$delete(this.list[i],"meanType");
          if(1 === this.list[i].type){
            this.list[i].type = 'click';
            this.$delete(this.list[i],"url");
            this.$delete(this.list[i],"chatContent");
            this.list[i].key = "mpcc_text_"+i+this.agentInfo.agentNumber;
          }else if(2 === this.list[i].type){
            this.list[i].type = 'view';
            this.$delete(this.list[i],"content");
            this.$delete(this.list[i],"chatContent");
            this.$delete(this.list[i],"key");
          }else if(3 === this.list[i].type){
            this.list[i].key = "mpcc_chat_"+i+this.agentInfo.agentNumber;
            this.list[i].type = 'click';
            this.list[i].chatContent += '';
            this.$delete(this.list[i],"content");
            this.$delete(this.list[i],"url");
          }
          for (let j = 0; j < this.list[i].sub_button.length; j++) {
            this.$delete(this.list[i],"key");
            this.$delete(this.list[i],"url");
            this.$delete(this.list[i],"type");
            this.$delete(this.list[i],"content");
            this.$delete(this.list[i],"chatContent");
            this.$delete(this.list[i].sub_button[j],"id");
            this.$delete(this.list[i].sub_button[j],"meanType");
            if(1 === this.list[i].sub_button[j].type){
              this.list[i].sub_button[j].type = 'click';
              this.$delete(this.list[i].sub_button[j],"url");
              this.$delete(this.list[i].sub_button[j],"chatContent");
              this.list[i].sub_button[j].key = "mpcc_text_"+i+j+this.agentInfo.agentNumber;
            }else if(2 === this.list[i].sub_button[j].type){
              this.list[i].sub_button[j].type = 'view';
              this.$delete(this.list[i].sub_button[j],"content");
              this.$delete(this.list[i].sub_button[j],"chatContent");
              this.$delete(this.list[i].sub_button[j],"key");
            }else if(3 === this.list[i].sub_button[j].type){
              this.list[i].sub_button[j].key = "mpcc_chat_"+i+j+this.agentInfo.agentNumber;
              this.list[i].sub_button[j].type = 'click';
              this.list[i].sub_button[j].chatContent +='';
              this.$delete(this.list[i].sub_button[j],"content");
              this.$delete(this.list[i].sub_button[j],"url");
            }
          }
        }
        if(this.menuStatus === 1 && this.list && this.list.length <= 0 || !this.list){
          this.$Message.error("开启后请添加至少一个菜单");
          return false;
        }
        let paramOne = {
          button:this.list,
        };
        let param = {
          channelOther:paramOne,
          journalType: "渠道管理=>微信=>自定义菜单保存发布",
          menuId: "null",
          isMenuOpen:this.menuStatus+'',
          id:this.searchId
        };
        let that = this;
        this.$http.post("chat/channel/doPushWeChatMenu.json",param) .then(function (res) {
          let result = res.data;
          if(result.flag!="666"){
            that.$Message.error(result.msg);
            return false;
          }
          that.$Message.success(result.msg);
          that.$emit('closecustommenu', false)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    // 初始化查询
    initSearch: function(){
      let param = {
        id:this.searchId,
        journalType: "系统管理=>会话配置=>渠道管理=>查询",
        menuId: "null"
      }
      let that = this;
      this.$http.post("chat/channel/toIndex.json",param) .then(function (res) {
        let result = res.data;
        if(result.flag!="666"){
          that.$Message.error(result.msg);
          return false;
        }
        let channel = result.obj.list.content[0];
        that.list = [];
        if(channel.channelOther){
          let newString = channel.channelOther;
          that.list = JSON.parse(newString).button;
          let number = 0;
          for (let i = 0; i < that.list.length; i++) {
            that.list[i].id=number;
            number++;
            that.list[i].meanType='0';
            if('click' === that.list[i].type && that.list[i].key.indexOf("text") !== -1){
              that.list[i].type = 1;
              that.list[i].url="";
              that.list[i].chatContent=1;
            }else if('view' === that.list[i].type || 'miniprogram' === that.list[i].type){
              that.list[i].type = 2;
              that.list[i].content='';
              that.list[i].chatContent=1;
            }else if('click' === that.list[i].type && that.list[i].key.indexOf("chat") !== -1){
              that.list[i].type = 3;
              that.list[i].content='';
              that.list[i].url="";
              that.list[i].chatContent = parseInt(that.list[i].chatContent);
            }else{
              that.list[i].type = 1;
              that.list[i].url="";
              that.list[i].chatContent=1;
              that.list[i].content='';
            }
            for (let j = 0; j < that.list[i].sub_button.length; j++) {
              that.list[i].sub_button[j].meanType='1';
              that.list[i].sub_button[j].id=number;
              number++;
              if('click' === that.list[i].sub_button[j].type && that.list[i].sub_button[j].key.indexOf("text") !== -1){
                that.list[i].sub_button[j].type = 1;
                that.list[i].sub_button[j].url="";
                that.list[i].sub_button[j].chatContent=1
              }else if('view' === that.list[i].sub_button[j].type || 'miniprogram' === that.list[i].sub_button[j].type){
                that.list[i].sub_button[j].type = 2;
                that.list[i].sub_button[j].content='';
                that.list[i].sub_button[j].chatContent=1
              }else if('click' === that.list[i].sub_button[j].type && that.list[i].sub_button[j].key.indexOf("chat") !== -1){
                that.list[i].sub_button[j].type = 3;
                that.list[i].sub_button[j].content='';
                that.list[i].sub_button[j].url="";
                that.list[i].sub_button[j].chatContent = parseInt(that.list[i].sub_button[j].chatContent);
              }
            }
          }
        }
        that.menuStatus = parseInt(channel.isMenuOpen);
      })
    },
  },
  watch: {
// 如果 `input` 发生改变，这个函数就会运行
    input: function () {
      for (let i = 0; i < this.list.length; i++) {
        for (let j = 0; j < this.list[i].sub_button.length; j++) {
          if (this.list[i].sub_button[j].id === this.id) {
            this.list[i].sub_button[j].name = this.input
          }
        }
        if (this.list[i].id === this.id) {
          this.list[i].name = this.input
        }
      }
    },
    showcustommenu: function () {
      this.model = this.showcustommenu;
      if(this.model){
        this.clickFlag=false;
        this.openPreview=false;
        this.isErrorFlag=false;
        this.listRightDetail={};
        this.activeClass = -1;
        this.addIndex=-1;
        this.isErrorFlag = false;
        this.initSearch();
      }
    }
  },

}
</script>

<style scoped >

  .flex{
    position: fixed;
    background: #000000;
    opacity: 0.5;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .preview{
    position: fixed;
    top: 15%;
    left: 45%;
    z-index: 99;
  }
  .previewCon{
    position: relative;
  }
  .previewArrow{
    position: absolute;
    bottom: -15px;
    left: 44%;
    width: 0;
    height: 0;
    font-size: 0;
    border: solid 8px;
    border-color:#fff #E6E6E6 #E6E6E6 #E6E6E6;
  }
  .warning {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 5px 20px;
  }
  .on {
    text-align: right;
    float: right;
    color: #1890ff;
  }
  .tips {
    color: #1890ff;
    font-size: 20px;
    margin-right: 10px;
  }
  .left {
    min-width: 390px;
    min-height: 460px;
    position: relative;
    padding-left: 40px;
  }
  .top {
    position: absolute;
    top: 0px;
    width: 82.4%;
  }
  .bottom {
    position: absolute;
    bottom: 0px;
  }
  .textBot {
    position: absolute;
    bottom: 0px;
    left: 80px;
    width: 100%;
  }
  .active {
    border: 1px solid #44B549 !important;
    color: #44B549 !important;
  }
  .li {
    float: left;
    width: 80px;
    line-height: 48px;
    border: 1px solid #E7E7EB;
    background: #FAFAFA;
    text-align: center;
    cursor: pointer;
    color: #999;
    position: relative;
  }
  .text{
    height: 50px;
  }
  .text:hover {
    color: #000;
  }
  .add {
    position: absolute;
    bottom: 65px;
    width: 100%;
    line-height: 48px;
    border: 1px solid #E7E7EB;
    background: #FAFAFA;
  }
  .arrow {
    position: absolute;
    bottom: -16px;
    left: 36px;
    width: 0;
    height: 0;
    font-size: 0;
    border: solid 8px;
    border-color:#ffffff #F4F5F9 #F4F5F9 #F4F5F9;
  }
  .addTheChild {
    position: absolute;
    bottom: 115px;
    width: 100%;
    line-height: 48px;
    background: #FAFAFA;
  }
  .addJiaFull {
    position: absolute;
    bottom: 55px;
    width: 100%;
    line-height: 48px;
    background: #FAFAFA;
  }
  .addClass {
    width: 100%;
    line-height: 48px;
    border: 1px solid #E7E7EB;
    background: #FAFAFA;
    height: 48px;
  }
  .right {
    background: #F4F5F9;
    min-height: 460px;
  }
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/CustommenuPop.vue